@if (avatarUrls()) {
  <div class="avatar-group -space-x-6">
    @for (avatarUrl of avatarUrls(); track avatarUrl) {
      <div class="avatar">
        <smallstack-avatar [url]="avatarUrl" [size]="size()"></smallstack-avatar>
      </div>
    }
  </div>
}
